@if (results$ | async; as results) {
	@if (workspaces && searchEngineAvailable) {
		<article class="search-results">
			<header class="page-header">
				<ul class="breadcrumb">
					<li>
						<a class="back" (click)="close()">
							<i class="ico ico-arrow-back"></i><span class="label" translate="back"></span>
						</a>
					</li>
				</ul>
				@if (loading) {
					<h1 translate="search.result.wait.title" [translateParams]="{ term: term }"></h1>
				}
				@if (!loading && totalResultsCount === 1) {
					<h1 translate="search.result.single.title" [translateParams]="{ term: term }"></h1>
				}
				@if (!loading && totalResultsCount > 1) {
					<h1 translate="search.result.multi.title" [translateParams]="{ count: totalResultsCount, term: term }"></h1>
				}
				@if (!loading && totalResultsCount === 0) {
					<h1 translate="search.result.none.title" [translateParams]="{ term: term }"></h1>
				}
			</header>
			<div class="container responsive-8-4">
				<article class="card col-8">
					<header>
						<div class="wrapper">
							<h5 translate="search.result.results.title" class="visible-gt-large"></h5>
							<h5 translate="filter.show" class="visible-lt-large"></h5>
							<div class="visible-lt-large switch-filter">
								<input id="search.filter" type="checkbox" hidden="hidden" [(ngModel)]="showFilter" />
								<label for="search.filter" class="switch"></label>
							</div>
						</div>
					</header>
					@if (showFilter) {
						<form class="form visible-lt-large">
							<stages-global-search-filter [typeFilterOptions]="typeFilterOptions"></stages-global-search-filter>
						</form>
					}
					@if (!loading) {
						<ul class="results">
							@for (result of $any(results.results); track result) {
								<li>
									@if (isFile(result)) {
										<div class="label">
											@if (isFileDownloadable(result)) {
												<a class="clickable" href="{{ getFileUrl(result.id, result.workspaceId) }}">
													<h4 [ngClass]="{ tailored: result.tailored }">{{ result.label }}</h4>
												</a>
											}
											@if (!isFileDownloadable(result)) {
												<h4 [ngClass]="{ tailored: result.tailored }">
													{{ result.label }}
												</h4>
											}
											@if (formatPath(result.containerElementPath, true); as path) {
												<h6>{{ path }}</h6>
											}
											<h6>{{ result.type.name }}</h6>
											@if (result.alternatives && result.alternatives.length >= 1) {
												<div class="further-workspaces">
													<stages-menu
														menuId="file-container-menu-{{ result.id }}"
														[noCollapse]="true"
														openTo="bottom"
														[items]="result.dropdown"
													>
														<span
															class="clickable"
															translate="search.result.results.file.containers"
															[translateParams]="{ count: result.alternatives.length + 1 }"
														></span>
													</stages-menu>
												</div>
											}
											@if (!result.alternatives || result.alternatives.length === 0) {
												<div class="further-workspaces">
													<a
														class="clickable"
														[routerLink]="createResultLink(result)"
														translate="search.result.results.file.container"
														[translateParams]="{
															elementName: result.containerElementName,
															workspaceName: result.workspaceName,
														}"
													></a>
												</div>
											}
										</div>
									}
									@if (!isFile(result)) {
										<div class="label">
											<a class="clickable" [routerLink]="createResultLink(result)">
												<h4 [ngClass]="{ tailored: result.tailored }">{{ result.label }}</h4>
											</a>
											<h6>{{ result.type.name }}</h6>
											@if (formatPath(result.path); as path) {
												<h6>{{ path }}</h6>
											}
											<h6>{{ result.workspaceName }}</h6>
											@if (result.alternatives && result.alternatives.length > 1) {
												<div class="further-workspaces">
													<stages-menu
														menuId="alternatives-menu-{{ result.identity }}"
														[noCollapse]="true"
														openTo="bottom"
														[items]="result.dropdown"
													>
														<span
															class="clickable"
															translate="search.result.results.further.workspaces"
															[translateParams]="{ count: result.alternatives.length }"
														></span>
													</stages-menu>
												</div>
											}
											@if (result.alternatives && result.alternatives.length === 1) {
												<div class="further-workspaces">
													<a
														class="clickable"
														[routerLink]="createResultLink(result.alternatives[0])"
														translate="search.result.results.further.workspace"
														[translateParams]="{ name: result.alternatives[0].workspaceName }"
													></a>
												</div>
											}
										</div>
									}
									<div class="preview">
										@if (isFile(result) && result.physicalPath) {
											<p>{{ result.physicalPath }}</p>
										}
										@if (isFile(result) && result.fileUrl) {
											<p>
												<a class="clickable" href="{{ result.fileUrl }}">{{ result.fileUrl }}</a>
											</p>
										}
										@if (result.description) {
											<p [innerHTML]="result.description"></p>
										}
										@for (dependentElementHit of result.dependentElementHits; track dependentElementHit) {
											@if (dependentElementHit.descriptionHit) {
												<p [innerHTML]="dependentElementHit.descriptionHit"></p>
											}
										}
										@if (hasAttributes(result) || hasDependentElementNames(result)) {
											<div class="horizontal-list">
												@for (entry of result.attributes | keyvalue; track entry) {
													<div class="content">
														<i class="ico ico-tag attribute-icon"></i>
														<h6 class="tag">{{ entry.value }}</h6>
													</div>
												}
												@for (dependentElementHit of result.dependentElementHits; track dependentElementHit) {
													<div class="content">
														<i
															[ngClass]="getDependentElementIconClasses(dependentElementHit)"
															[title]="getDependentElementTooltip(dependentElementHit) | async"
															[attr.aria-label]="getDependentElementTooltip(dependentElementHit) | async"
														></i>
														<h6 class="tag">{{ dependentElementHit.name }}</h6>
													</div>
												}
											</div>
										}
									</div>
								</li>
							}
						</ul>
					} @else {
						<stages-spin class="spin-without-button" size="sm"></stages-spin>
					}
					<div class="clear"></div>
					@if (!results.results.length && !loading) {
						<p class="empty">
							<span translate="search.result.results.empty" [translateParams]="{ term: term }"> </span>
						</p>
						@if (overviewResultsCountFromOtherWorkspaces$ | async; as otherCount) {
							@if (otherCount > 0) {
								<p class="empty">
									<span class="clickable" (click)="goToPage(1, 'all')" translate="search.result.search.all"></span>
								</p>
							}
						}
					}
					@if (!loading) {
						<footer>
							<stages-pager
								[total]="totalResultsCount"
								[page]="page"
								[pageSize]="resultsSize"
								(goTo)="goToPage($event)"
							></stages-pager>
						</footer>
					}
				</article>
				<article class="card facets col-4 visible-gt-large">
					<form class="form">
						<stages-global-search-filter [typeFilterOptions]="typeFilterOptions"></stages-global-search-filter>
					</form>
				</article>
			</div>
		</article>
	}
} @else {
	@if (searchEngineAvailable) {
		<header class="page-header">
			<ul class="breadcrumb">
				<li>
					<a class="back" (click)="close()">
						<i class="ico ico-arrow-back"></i><span class="label" translate="back"></span>
					</a>
				</li>
			</ul>
			<h1 translate="search.result.wait.title" [translateParams]="{ term: term }"></h1>
		</header>
	}
	@if (searchEngineAvailable) {
		<div class="container responsive-8-4">
			<article class="card col-8">
				<header>
					<div class="wrapper">
						<h5 translate="search.result.results.title" class="visible-gt-large"></h5>
					</div>
				</header>
				@if (!loading) {
					<ul class="results">
						<li>
							<stages-spin class="spin-without-button" size="sm"></stages-spin>
						</li>
					</ul>
				} @else {
					<stages-spin class="spin-without-button" size="sm"></stages-spin>
				}
			</article>
		</div>
	}
}

@if (!searchEngineAvailable) {
	<article class="search-results">
		<!-- Displayed when the search is not available. -->
		<header class="page-header">
			<ul class="breadcrumb">
				<li>
					<a class="back" (click)="close()">
						<i class="ico ico-arrow-back"></i><span class="label" translate="back"></span>
					</a>
				</li>
			</ul>
			<h1 translate="search.notavailable.title"></h1>
		</header>
		<div class="container responsive-8-4">
			<article class="card col-8">
				<header>
					<div class="wrapper">
						<h5 translate="search.result.results.title" class="visible-gt-large"></h5>
					</div>
				</header>
				<div class="clear"></div>
				<p class="empty" translate="search.notavailable"></p>
			</article>
		</div>
	</article>
}
